export default __webpack_public_path__ + "static/media/argentan14.8c065a9f.jpg";